import { Action } from 'redux';

export interface PeopleState {
  loadingPeople: boolean;
  savingPerson: boolean;
  removingPerson: boolean;
  people: any[];
  selectedIndex: number | null;
  isEditing: boolean;
  searchQuery: string;
  filters: {
    status: string;
    gender: string;
    under_age: boolean;
  };
}

export enum PeopleActionTypes {
  EDITING_START = '@@people/EDITING_START',
  EDITING_CANCEL = '@@people/EDITING_CANCEL',
  GET_PEOPLE_START = '@@people/GET_PEOPLE_START',
  GET_PEOPLE_SUCCESS = '@@people/GET_PEOPLE_SUCCESS',
  GET_PEOPLE_ERROR = '@@people/GET_PEOPLE_ERROR',
  SAVE_PERSON_START = '@@people/SAVE_PERSON_START',
  SAVE_PERSON_SUCCESS = '@@people/SAVE_PERSON_SUCCESS',
  SAVE_PERSON_ERROR = '@@people/SAVE_PERSON_ERROR',
  REMOVE_PERSON_START = '@@people/REMOVE_PERSON_START',
  REMOVE_PERSON_SUCCESS = '@@people/REMOVE_PERSON_SUCCESS',
  REMOVE_PERSON_ERROR = '@@people/REMOVE_PERSON_ERROR',
  SET_PEOPLE_FILTERS = '@@people/SET_PEOPLE_FILTERS',
  SET_SEARCH_QUERY = '@@people/SET_SEARCH_QUERY',
  CLEAR = '@@people/CLEAR',
}

export interface PeopleAction extends Action<PeopleActionTypes> {
  index?: number;
  people?: PeopleState['people'];
  searchQuery?: PeopleState['searchQuery'];
  filters?: PeopleState['filters'];
}
